import { EmailsIcon } from "@minket/brand/icons/emails";
import { SendIcon } from "@minket/brand/icons/send";
import { createFileRoute } from "@tanstack/react-router";
import { GhostTable } from "@/components/page/ghost";
import { Page } from "@/components/page/page";
import { ProjectScope } from "@/components/page/scope";
import { SendTestAction } from "@/components/sending/actions";
import { GatedAction } from "@/components/sending/available";
import { EmailLedger, ledgerColumns, ledgerWidths } from "@/components/sending/ledger";
import { useSendVolume } from "@/components/sending/volume";

export const Route = createFileRoute("/emails/")({
  component: Emails,
});

const will = "Each email this project sends will be listed here with what happened to it.";

function Emails() {
  const volume = useSendVolume("live");
  return (
    <Page
      title="Sent"
      trace={volume?.days}
      description={
        volume && volume.total > 0 ? (
          <>
            <span className="type-data whitespace-nowrap text-foreground">
              {volume.total.toLocaleString("en-GB")}
            </span>{" "}
            in the last 30 days.
          </>
        ) : undefined
      }
      action={
        <GatedAction
          list="emails"
          pending={{ label: "Send test email", icon: SendIcon }}
          permission="emails.send"
          forbidden="Viewers cannot send email"
        >
          {(projectId) => <SendTestAction projectId={projectId} />}
        </GatedAction>
      }
    >
      <ProjectScope
        will={will}
        icon={<EmailsIcon size={20} />}
        preview={(busy) => (
          <GhostTable columns={ledgerColumns} widths={ledgerWidths} label="emails" busy={busy} />
        )}
      >
        {(scoped) => (
          <EmailLedger
            projectId={scoped.id}
            list="emails"
            icon={EmailsIcon}
            noun="emails"
            empty={{
              title: "No emails yet",
              description: (
                <>
                  Mail sent with a live key appears here as Minket accepts it. Send a test email, or
                  send from your app with <code className="type-data">MINKET_API_KEY</code>.
                </>
              ),
            }}
          />
        )}
      </ProjectScope>
    </Page>
  );
}
